import filter from 'lodash/filter';

import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from '../shared/emptyObserverCreator';
import { User } from 'src/models/Users/User';

const organizationUsersResource = createCollectionResource<User>({
  name: 'organizationUsers',
  endpoint: 'v1/orgs/:orgId/users',
  observerCreator: emptyObserverCreator,
  reducers: {
    fetchSuccess(state, action) {
      state.loadingState = 'succeeded';
      state.values = filter(action.payload, user => !user.disabledAt);
    },
  },
});

export default organizationUsersResource;
